import script from "./DesignFormModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DesignFormModal.vue?vue&type=script&setup=true&lang=js"

import "./DesignFormModal.vue?vue&type=style&index=0&id=6c357e3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c357e3c"]])

export default __exports__